import React from 'react';
import { ViewResolver } from '@Components/ViewResolver';
import ContactListDesktop from './desktop/ContactListDesktop';
import ContactListMobile from './mobile/ContactListMobile';
import { ContactListProps } from './types';
import styles from './contact-list.module.css';

const ContactList: React.FC<ContactListProps> = (props) => {
  return (
    <div className={styles.contactList}>
      <ViewResolver
        desktop={<ContactListDesktop {...props} />}
        mobile={<ContactListMobile {...props} />}
      />
    </div>
  );
};

export default ContactList;
